import { Button, Skeleton } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useRouter } from 'next/router';
import { useCreateAndNavToTest } from '~/hooks/api/useCreateAndNavToTest';
import { api } from '~/trpc-extra/api';
import { queryParamToString } from '~/logic/query-param';
import { DataTable } from '../tables/common/DataTable';
import { recentTestColumns } from '../tables/test/recentTestColumns';
import { useDataTable } from '../tables/common/useDataTable';

export default function ProjectTest({ defaultLimit }: { defaultLimit?: number }) {
  const router = useRouter();
  const projectId = queryParamToString(router.query.projectId);

  const { data: tests, isLoading: isTestsLoading } = api.test.listTests.useQuery({ projectId, limit: defaultLimit });

  const createTestHandler = useCreateAndNavToTest({});

  const table = useDataTable({ columns: recentTestColumns, data: tests ?? [] });

  return (
    <>
      {!isTestsLoading && (
        <div>
          <DataTable
            table={table}
            onRowClick={(row) => router.push(`/project/${projectId}/test/${row.original.id}`)}
            className="bg-inherit"
          />
          <hr className="dark:border-gray-700" />
        </div>
      )}
      {isTestsLoading ?
        <Skeleton>&nbsp;</Skeleton>
      : null}
      {!isTestsLoading && tests?.length === 0 && (
        <div className="grid flex-grow justify-start">
          <div className="pt-4">
            <Button
              variant="gradient"
              onClick={
                !isTestsLoading && tests !== undefined && tests.length > 0 ?
                  () => router.push(`/project/${projectId}/test`).catch(() => undefined)
                : createTestHandler
              }
              leftSection={<IconPlus />}
            >
              Create a test
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
